/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from "@ngrx/store";
import { ElectricalSettingsActionNames } from "./electrical-settings-action-names";
import { ElectricalSettingsInformation, ElectricalSettingsObjectInformation } from "../../models/electrical-settings-information";
import { ElectricalSettingsObject } from "../../models/electrical-settings-shortcuts";
import { ElectricalSettingsStatusResult } from "../../models/electrical-settings-return";

export const GetElectricalSystemsInformation = createAction(
    ElectricalSettingsActionNames.GetElectricalSystemsInformation()
);

export const GetElectricalSystemsInformationSuccess = createAction(
    ElectricalSettingsActionNames.GetElectricalSystemsInformationSuccess(),
    props<{ electricalInformation: ElectricalSettingsObjectInformation}>()
);

export const GetElectricalShortcutsModifiersInformation = createAction(
    ElectricalSettingsActionNames.GetElectricalShortcutsModifiersInformation()
);

export const GetElectricalShortcutsModifiersInformationSuccess = createAction(
    ElectricalSettingsActionNames.GetElectricalShortcutsModifiersInformationSuccess(),
    props<{ shortcuts: ElectricalSettingsObject}>()
);

export const GetInvalidShortcuts = createAction(
    ElectricalSettingsActionNames.GetInvalidShortcuts(),
    props<{ electricalSettings: ElectricalSettingsInformation }>()
);

export const GetInvalidShortcutsSuccess = createAction(
    ElectricalSettingsActionNames.GetInvalidShortcutsSuccess(),
    props<{ invalidShortcuts: ElectricalSettingsStatusResult}>()
);

export const ApplyPreferences = createAction(
    ElectricalSettingsActionNames.ApplyPreferences(),
    props<{ electricalSettings: ElectricalSettingsInformation }>()
);

export const ApplyPreferencesSuccess = createAction(
    ElectricalSettingsActionNames.ApplyPreferencesSuccess(),
);